import { useEffect, useState } from 'react';

// Reads the non-credential flag cookie set by the admin panel
// (`mdai_authed=1`, scoped to the shared parent domain). Returns true
// when the user is currently signed in to the portal.
const FLAG_COOKIE = 'mdai_authed';

function readFlag() {
  if (typeof document === 'undefined') return false;
  return document.cookie
    .split(';')
    .some((s) => s.trim().startsWith(`${FLAG_COOKIE}=1`));
}

export function useAuthStatus() {
  const [authed, setAuthed] = useState(() => readFlag());

  useEffect(() => {
    // The cookie is set on another origin (the portal), so we can't subscribe
    // to it directly. Re-read whenever the tab regains focus so a user who
    // just signed in elsewhere sees the UI update on return.
    const check = () => setAuthed(readFlag());
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);

  return authed;
}
